'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const themeTokens = {
  alertNoneNone: 1,
  assetpanelcontainerNoneNone: 1,
  bodytextDefaultNone: 1,
  bodytextEmphasisNone: 1,
  buttonsDismissNone: 1,
  buttonsPrimaryDefault: 1,
  buttonsPrimaryDisabled: 1,
  buttonsPrimaryHover: 1,
  buttonsSecondaryDefault: 1,
  buttonsSecondaryDisabled: 1,
  buttonsSecondaryHover: 1,
  calendarInputDefault: 1,
  calendarInputDisabled: 1,
  calendarInputSelected: 1,
  calendarStaticDefault: 1,
  calendarStaticSelected: 1,
  captiontextDefaultNone: 1,
  captiontextErrorNone: 1,
  chatbubbleImageNone: 1,
  chatbubbleMeNone: 1,
  chatbubbleThemNone: 1,
  dividerPrimaryNone: 1,
  documentbodyNoneNone: 1,
  eddcalculatorcontainerNoneNone: 1,
  floatingpillNoneNone: 1,
  footertextNoneNone: 1,
  gradientNoneNone: 1,
  headersBigNone: 1,
  headersHugeNone: 1,
  headersMediumNone: 1,
  headersSemibigNone: 1,
  headersSmallNone: 1,
  iconsFooterNone: 1,
  iconsPrimaryNone: 1,
  iconsSecondaryNone: 1,
  imgPrimaryNone: 1,
  inputcheckboxesNoneDefault: 1,
  inputcheckboxesNoneSelected: 1,
  inputlabelNoneDisabled: 1,
  inputlabelNoneNone: 1,
  inputratingstarsNoneDefault: 1,
  inputratingstarsNoneSelected: 1,
  inputtextareasNoneDisabled: 1,
  inputtextareasNoneFocus: 1,
  inputtextareasNoneNone: 1,
  inputtextinputsNoneDisabled: 1,
  inputtextinputsNoneError: 1,
  inputtextinputsNoneFocus: 1,
  inputtextinputsNoneNone: 1,
  linksLegalDefault: 1,
  linksLegalHover: 1,
  linksNoneDefault: 1,
  linksNoneHover: 1,
  linksNoneVisited: 1,
  linksTrackingDefault: 1,
  linksTrackingHover: 1,
  narvarfooterNoneNone: 1,
  panelbodyNoneNone: 1,
  panelcontainerNoneNone: 1,
  panelcontainerNoneHover: 1,
  panelcontainerNoneActive: 1,
  panelfooterNoneNone: 1,
  panelheaderNoneNone: 1,
  productrecspanelcontainerNoneNone: 1,
  productrecsarrowcontainerNextNone: 1,
  productrecsarrowcontainerPrevNone: 1,
  productrecsarrowNoneDefault: 1,
  productrecsarrowNoneDisabled: 1,
  productrecsarrowNoneHover: 1,
  productrecscarouseltitleNoneNone: 1,
  productrecsdotcontainerNoneNone: 1,
  productrecsdotNoneActive: 1,
  productrecsdotNoneDefault: 1,
  productrecsdotNoneHover: 1,
  productrecsreccontainerNoneNone: 1,
  productrecsrecimageNoneNone: 1,
  productrecsrecpriceCentsNone: 1,
  productrecsrecpriceNoneNone: 1,
  productrecsrecpriceOldNone: 1,
  productrecsrecpricePriceNone: 1,
  productrecsrecpriceSaleNone: 1,
  productrecsrecpriceStrikethroughcentsNone: 1,
  productrecsrecpriceUsdNone: 1,
  productrecsrecratingcontainerNoneNone: 1,
  productrecsrecratingstarEmptyNone: 1,
  productrecsrecratingstarFullNone: 1,
  productrecsrectextBrandNone: 1,
  productrecsrectextNameNone: 1,
  productrecsrectextNoneNone: 1,
  productrecsrectextReviewsNone: 1,
  productrecsrectextStaticNone: 1,
  productrecsrectextStrikethroughNone: 1,
  progressbarmarkerDeliveredDefault: 1,
  progressbarmarkerEddDefault: 1,
  progressbarmarkerShippedAfter: 1,
  progressbarmarkerShippedBefore: 1,
  sectiondividerPrimaryNone: 1,
  selecteditemNoneNone: 1,
  smalltextDefaultNone: 1,
  smalltextEmphasisNone: 1,
  spinnerPrimaryNone: 1,
  telephoneinputNoneNone: 1,
  selectNoneNone: 1
};
function proxyRetailerTheme(theme, requestedThemeTokens) {
  return new Proxy(theme, {
    get(target, property) {
      if (typeof property === 'string' && Object.prototype.hasOwnProperty.call(themeTokens, property) && !requestedThemeTokens.includes(property)) {
        throw new Error(`themeToken was not requested: ${property}`);
      }
      return Reflect.get(target, property);
    }
  });
}

exports["default"] = proxyRetailerTheme;
